import { StylesConfig } from 'react-select';
import { backgroundColor } from '../../Resource/FormTemplates/Inputs/MultipleSelectionsInput';

export interface CustomStylesConfig<TValue> extends StylesConfig<TValue> {}

export function createStylesConfig<TValue>(): CustomStylesConfig<TValue> {
  return {
    control: (baseStyles, state) => ({
      ...baseStyles,
      fontSize: '0.875rem',
      fontWeight: '500',
      borderColor: state.isFocused ? '#187A90' : '#BEC0C5',
      cursor: state.isDisabled ? 'not-allowed' : 'default',
      '&:hover': {
        borderColor: '#187A90',
        color: '#187A90',
      },
    }),
    option: (styles, { isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: backgroundColor(isFocused, isSelected),
        color: isSelected ? 'white' : 'black',
        fontSize: '0.875rem',
        fontWeight: '500',
      };
    },
    menu: (styles) => ({ ...styles, zIndex: 40 }),
    menuPortal: (base) => ({ ...base, zIndex: 40 }),
    indicatorSeparator: () => ({ display: 'none' }),
    dropdownIndicator: () => ({ color: 'black' }),
  };
}
